import { CostSummary } from '@webapp/core/components/CostSummary'
import { Price } from '@webapp/core/components/Price'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useExpenseCostSummaryPresenter } from './useExpenseCostSummaryPresenter'

interface IExpenseCostSummaryPresenterProps {
  uuid: string
}

export const ExpenseCostSummaryPresenter = ({
  uuid,
}: IExpenseCostSummaryPresenterProps) => {
  const intl = useProcurifyIntl()
  const {
    data: { subtotal, taxTotal, totalAmount, reimbursableAmount, currencyName },
    states: { isLoading },
  } = useExpenseCostSummaryPresenter({ uuid })

  if (isLoading || !currencyName) return null

  return (
    <CostSummary>
      <CostSummary.Cost>
        <th id='footer-cost-summary-subtotal'>
          {intl.formatMessage(messages.subtotalLabel)}
        </th>
        <td>
          <Price
            price={subtotal}
            currency={currencyName}
            fontSize={14}
            aria-labelledby='footer-cost-summary-subtotal'
          />
        </td>
      </CostSummary.Cost>
      <CostSummary.Cost>
        <th id='footer-cost-summary-tax'>
          {intl.formatMessage(messages.taxLabel)}
        </th>
        <td>
          <Price
            price={taxTotal}
            currency={currencyName}
            fontSize={14}
            aria-labelledby='footer-cost-summary-tax'
          />
        </td>
      </CostSummary.Cost>
      <CostSummary.Total>
        <th id='footer-cost-summary-total'>
          {intl.formatMessage(messages.totalLabel)}
        </th>
        <td>
          <Price
            price={totalAmount}
            currency={currencyName}
            fontSize={18}
            aria-labelledby='footer-cost-summary-total'
          />
        </td>
      </CostSummary.Total>
      <CostSummary.Cost>
        <th id='footer-cost-summary-reimbursable'>
          {intl.formatMessage(messages.reimbursableLabel)}
        </th>
        <td>
          <Price
            price={reimbursableAmount}
            currency={currencyName}
            fontSize={14}
            aria-labelledby='footer-cost-summary-reimbursable'
          />
        </td>
      </CostSummary.Cost>
    </CostSummary>
  )
}

ExpenseCostSummaryPresenter.displayName =
  'ExpenseCostSummaryPresenter'
